import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Download, Loader2 } from 'lucide-react';

export default function CompareExportDialog({
  open, defaultFilename, onCancel, onConfirm,
}) {
  const { t } = useTranslation();
  const [filename, setFilename] = useState(defaultFilename);
  const [includeSummary, setIncludeSummary] = useState(true);
  const [busy, setBusy] = useState(false);

  if (!open) return null;

  async function handleConfirm(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await onConfirm({ filename, includeSummary });
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center px-4 bg-gray-900/40">
      <form
        onSubmit={handleConfirm}
        className="bg-white rounded-2xl shadow-2xl border border-gray-200 w-full max-w-md p-6"
      >
        <h2 className="text-lg font-semibold text-gray-900 mb-4">
          {t('tools:compare.export_heading', 'Download diff PDF')}
        </h2>

        <label className="block text-sm font-medium text-gray-700 mb-1.5">
          {t('tools:compare.export_filename_label', 'Save as')}
        </label>
        <input
          type="text"
          value={filename}
          onChange={(e) => setFilename(e.target.value)}
          required
          className="w-full rounded-lg border border-gray-300 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-500"
        />

        <label className="flex items-center gap-2 mt-4 text-sm text-gray-700 cursor-pointer">
          <input
            type="checkbox"
            checked={includeSummary}
            onChange={(e) => setIncludeSummary(e.target.checked)}
          />
          {t('tools:compare.export_include_summary', 'Include summary page')}
        </label>

        <div className="mt-6 flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={busy}
            className="px-4 py-2 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100"
          >
            {t('common:buttons.cancel')}
          </button>
          <button
            type="submit"
            disabled={busy || !filename.trim()}
            className="flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50"
          >
            {busy ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} />}
            {t('tools:compare.export_button', 'Download diff PDF')}
          </button>
        </div>
      </form>
    </div>
  );
}
